/**
 * KAN-928: видимость серий графика "Лиды по дням". По умолчанию видны все;
 * выбор запоминается в localStorage (persistedState: ошибки хранилища не ломают график).
 */
import { useCallback, useState } from 'react';
import { loadJson, saveJson } from '@/lib/persistedState';
import {
  CRM_STATS_CHART_STORAGE_KEY,
  parseHiddenSeries,
  toggleHiddenSeries,
  type CrmStatsChartSeriesKey,
} from '@/lib/crmStatsChartSeries';

export interface CrmStatsChartSeriesVisibility {
  isHidden: (key: CrmStatsChartSeriesKey) => boolean;
  toggle: (key: CrmStatsChartSeriesKey) => void;
}

export function useCrmStatsChartSeries(): CrmStatsChartSeriesVisibility {
  const [hidden, setHidden] = useState<CrmStatsChartSeriesKey[]>(() =>
    parseHiddenSeries(loadJson(CRM_STATS_CHART_STORAGE_KEY))
  );

  const toggle = useCallback((key: CrmStatsChartSeriesKey) => {
    setHidden((prev) => {
      const next = toggleHiddenSeries(prev, key);
      saveJson(CRM_STATS_CHART_STORAGE_KEY, next);
      return next;
    });
  }, []);

  const isHidden = useCallback((key: CrmStatsChartSeriesKey) => hidden.includes(key), [hidden]);

  return { isHidden, toggle };
}
